// Generated types for ChatSkillsTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { PDMProductWriteAPI } from '../../pdm/types/pdmproduct';
import { ProjectWriteAPI } from '../../rflp/types/project';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { ThreadWriteAPI } from '../../chat/types/thread';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { PDMProductWriteAPISchema } from '../../pdm/types/pdmproduct';
import { ProjectWriteAPISchema } from '../../rflp/types/project';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';
import { ThreadWriteAPISchema } from '../../chat/types/thread';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ChatSkillsTaskReadAPI extends TaskReadAPI {
}

export interface ChatSkillsTaskWriteAPI extends TaskWriteAPI {
  thread?: string | ThreadWriteAPI;
  currently_attached_to?: string | PDMProductWriteAPI | ProjectWriteAPI;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ChatSkillsTaskReadAPISchema: z.ZodType<ChatSkillsTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ChatSkillsTaskWriteAPISchema: z.ZodType<ChatSkillsTaskWriteAPI> = TaskWriteAPISchemaObject.extend({
  thread: z.union([z.string(), z.lazy(() => ThreadWriteAPISchema)]).optional(),
  currently_attached_to: z.union([z.string(), z.lazy(() => PDMProductWriteAPISchema), z.lazy(() => ProjectWriteAPISchema)]).optional(),
}).passthrough();
